module.exports = __webpack_public_path__ + "static/img/4.5df2330.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/4.png
// module id = by45
// module chunks = 4